import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getAirwaySelector } from '../selectors'
import { saveAirway } from '../store/airway.actions'
import { AirwayConstants } from '../store/airway.constants'
import { IAirwayState } from '../store/airway.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setComments() {
  const airwayState: IAirwayState = yield select(getAirwaySelector)
  const { comments } = airwayState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.airwayStateList && pcrDoc.patient?.airwayStateList.length) {
        const index = pcrDoc.patient?.airwayStateList?.findIndex((airway) => airway.key === airwayState.key)
        if (index !== -1) {
          if (pcrDoc.patient.airwayStateList[index].comments !== comments) {
            yield put(saveAirway())
          }
        }
      } else {
        yield put(saveAirway())
      }
    } catch (e) {
      yield put(throwPcrException(`setComments() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([AirwayConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
